import { trigger, transition,query,animate,style, group } from '@angular/animations';

export const routeTransition = trigger('routeTransition', [
    // transition('* => *', [
    //     query(':enter', [
    //         style({ opacity: 0, scale: 0.8 }),
    //     ], { optional: true }),
    //     query(':leave', [
    //         animate('0.3s', style({ opacity: 0, scale: 0.8}))
    //     ], { optional: true }),
    //     query(':enter', [
    //         animate('0.3s', style({ opacity: 1, scale: 1 }))
    //     ], { optional: true })
    // ])
    transition('* => *', [
        query(':enter, :leave', [
            style({
              position: 'absolute',
              left: 0,
              width: '100%'
            })
        ], { optional: true }),
        query(':enter', [
            style({ left: '-100%'})
        ]),
          group([
            query(':leave', [
              animate('600ms ease', style({ left: '100%'}))
            ], { optional: true }),
            query(':enter', [
              animate('600ms ease', style({ left: '0%'}))
            ])
          ]),
    ])
]);